import { RuntimeMistakeRetryScreen } from '@/features/unified-learning/runtime/screens/RuntimeMistakeRetryScreen';

export default function LearnMistakeRetryRoute() {
  return <RuntimeMistakeRetryScreen />;
}
